module.exports = __webpack_public_path__ + "img/my_data.13363971.png";